var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-version"},[_vm._v("Версия: "),_c('span',[_vm._v("1.0.2")])])}]

export { render, staticRenderFns }